import * as React from 'react';

const ShareIcon = ({color = 'currentColor', size = 24}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 256 256"
        xmlSpace="preserve"
    >
        <g
            style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
            }}
        >
            <path
                d="M70.584 51.148c-6.331 0-11.947 3.06-15.493 7.763l-17.039-8.513c.498-1.716.779-3.524.779-5.399s-.281-3.682-.779-5.398l17.039-8.513c3.547 4.703 9.162 7.762 15.493 7.762C81.29 38.852 90 30.142 90 19.436S81.29.02 70.584.02 51.168 8.73 51.168 19.436c0 1.875.281 3.682.779 5.399l-17.038 8.512c-3.547-4.703-9.162-7.763-15.493-7.763C8.71 25.584 0 34.294 0 45s8.71 19.416 19.416 19.416c6.331 0 11.946-3.06 15.493-7.763l17.038 8.513a19.3 19.3 0 0 0-.779 5.399c0 10.705 8.71 19.415 19.416 19.415S90 81.27 90 70.564s-8.71-19.416-19.416-19.416m0-44.128C77.431 7.02 83 12.59 83 19.436s-5.569 12.416-12.416 12.416-12.416-5.569-12.416-12.416S63.737 7.02 70.584 7.02M19.416 57.416C12.57 57.416 7 51.847 7 45s5.57-12.416 12.416-12.416S31.832 38.153 31.832 45s-5.57 12.416-12.416 12.416m51.168 25.563c-6.847 0-12.416-5.569-12.416-12.415 0-6.847 5.569-12.416 12.416-12.416S83 63.718 83 70.564s-5.569 12.415-12.416 12.415"
                style={{
                    stroke: "none",
                    strokeWidth: 1,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: color,
                    fillRule: "nonzero",
                    opacity: 1,
                }}
                transform="translate(1.407 1.407)scale(2.81)"
            />
        </g>
    </svg>
);
export default ShareIcon;